package com.nonopn.skywatcher.design.widgets

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.Text
import androidx.compose.material.TopAppBar
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Menu
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.compose.widgets.spacers.TopSpacer

@Composable
fun TopAppBarExtended(
    title: String,
    topSpacer: Boolean,
    canGoBack: Boolean,
    isScreenExpanded: Boolean, // unused for now in the app
    appModel: AppBarStateProvider,
    onNavigationClick: () -> Unit
) {
    val modelState by appModel.states.collectAsState()
    val isDarkTheme = LocalDarkTheme.current

    val appBarState = modelState.appBarState

    val menu = if (canGoBack) {
        Icons.AutoMirrored.Filled.ArrowBack
    } else if (!isScreenExpanded) {
        Icons.Filled.Menu
    } else {
        null
    }

    val tint = if (isDarkTheme) AppColor.White else AppColor.Black

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        if (topSpacer) {
            TopSpacer(
                if (isDarkTheme) {
                    Color.Black
                } else {
                    Color.White
                }
            )
        }

        TopAppBar(
            elevation = 4.dp,
            title = {
                Text(
                    fontSize = LocalFontSizes.current.actionBar.title,
                    text = title,
                    color = tint
                )
            },
            backgroundColor = if (isDarkTheme) AppColor.Black else AppColor.White,
            navigationIcon = if (null != menu) {
                {
                    IconButton(
                        onClick = onNavigationClick
                    ) {
                        Icon(
                            menu,
                            null,
                            tint = tint
                        )
                    }
                }
            } else {
                null
            },
            actions = {
                appBarState.actions?.forEach {
                    it.Draw(this, tint)
                }
            }
        )
    }
}
